function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#FFF",
  strokeLinecap: "square",
  strokeWidth: 2,
  opacity: 0.901
}, React.createElement("path", {
  d: "M2 1.5L22.5 22M23 1.5L2.5 22"
}));

var SvgClose = function SvgClose(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 24
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNSIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI1IDI0Ij4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZT0iI0ZGRiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgc3Ryb2tlLXdpZHRoPSIyIiBvcGFjaXR5PSIuOTAxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDEpIj4KICAgIDxwYXRoIGQ9Ik0wLDAuNSBMMjAuNSwyMSIvPgogICAgPHBhdGggZD0iTTAsMC41IEwyMC41LDIxIiB0cmFuc2Zvcm09Im1hdHJpeCgtMSAwIDAgMSAyMSAwKSIvPgogIDwvZz4KPC9zdmc+Cg==";
export { SvgClose as ReactComponent };